<p-panel>
  <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
    <app-reactive-form-builder
      #formbuilder
      (goBack)="goBack()"
      (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
      (stableValueChanges)="stableValueChanges($event)"
      [form]="form.formFields"
      [getRequest]="getRequest"
      [id]="reactiveFormRecordId"
      [previousData]="initialPreviousData"
      [request]="request"
      [serverUrl]="''"
      [undoEnabled]="undoEnabled">
    </app-reactive-form-builder>
  </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
  <div class="p-3 text-center" role="status" aria-live="polite">
    <div *ngIf="!reactiveFormLoadingError" class="text-muted">
      {{ reactiveFormLoadingLabel }}
    </div>
    <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
      {{ reactiveFormLoadingError }}
    </div>
  </div>
</ng-template>

<p-dialog
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <div [formGroup]="comunidadForm" class="p-fluid">
    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="form.openDialog = false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>
